export { Center } from '@mantine/core'